export var ITEMS_GAP = 20;
export var ProgressBarVariables;
(function (ProgressBarVariables) {
  ProgressBarVariables["OFFSET"] = "--progress-bar-progress-left";
  ProgressBarVariables["WIDTH"] = "--progress-bar-progress-width";
  ProgressBarVariables["MASK"] = "--progress-bar-bg-mask";
  ProgressBarVariables["TRANSITION"] = "--progress-bar-transition";
})(ProgressBarVariables || (ProgressBarVariables = {}));
export var getLineSize = function getLineSize(totalWidth, steps) {
  return Math.max(totalWidth - (steps - 1) * ITEMS_GAP, 0) / steps;
};
export var generateMask = function generateMask(blockSize, sizes) {
  var length = sizes.length;
  if (length > 0) {
    var width = blockSize * length + ITEMS_GAP * (length - 1);
    var svg = "%3csvg width='".concat(width, "px' height='4px' xmlns='http://www.w3.org/2000/svg'%3e");
    for (var index = 0; index < length; index += 1) {
      var x = blockSize * index + ITEMS_GAP * index;
      svg += "%3crect x='".concat(x, "px' y='", 0, "px' rx='2px' ry='2px' height='4px' width='").concat(sizes[index], "px' /%3e");
    }
    svg += '%3c/svg%3e';
    return "url(\"data:image/svg+xml;charset=UTF-8,".concat(svg, "\")");
  }
  return '';
};